import template from './otbNavbar.html';
import controller from './otbNavbar.controller';

let otbNavbarComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  controllerAs: 'vm'
};

export default otbNavbarComponent;



// WEBPACK FOOTER //
// ./client/app/common/otbNavbar/otbNavbar.component.js